import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { NAME_PATTERN, OPTIONAL_NAME_PATTERN, UK_PHONE_NUMBER_PATTERN, } from '../utils/regex.js';
export class PersonalDetails extends BaseMessage {
    firstname;
    middlename;
    surname;
    dateOfBirth;
    mobileNumber;
}
__decorate([
    Field.string({
        description: 'First Name of an individual',
        required: true,
        maxLength: 30,
        pattern: NAME_PATTERN,
    }),
    __metadata("design:type", String)
], PersonalDetails.prototype, "firstname", void 0);
__decorate([
    Field.string({
        description: 'Middle Name of an individual',
        required: false,
        maxLength: 30,
        pattern: OPTIONAL_NAME_PATTERN,
    }),
    __metadata("design:type", String)
], PersonalDetails.prototype, "middlename", void 0);
__decorate([
    Field.string({
        description: 'Last Name of an individual',
        required: true,
        maxLength: 80,
        pattern: NAME_PATTERN,
    }),
    __metadata("design:type", String)
], PersonalDetails.prototype, "surname", void 0);
__decorate([
    Field.string({
        description: 'Birth date of an individual',
        required: false,
        format: 'date',
    }),
    __metadata("design:type", String)
], PersonalDetails.prototype, "dateOfBirth", void 0);
__decorate([
    Field.string({
        description: 'Phone Number of an individual',
        required: true,
        maxLength: 11,
        pattern: UK_PHONE_NUMBER_PATTERN,
    }),
    __metadata("design:type", String)
], PersonalDetails.prototype, "mobileNumber", void 0);
//# sourceMappingURL=PersonalDetails.js.map